import { useState } from "react";
import { useAuth } from "../lib/AuthContext";
import { COLORS } from "../lib/colors";

export default function LoginPage() {
  const { signIn, resetPassword } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [resetSent, setResetSent] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await signIn(email, password);
    } catch (err) {
      setError(err.message || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  const handleReset = async () => {
    if (!email) { setError("Enter your email first"); return; }
    try {
      await resetPassword(email);
      setResetSent(true);
    } catch (err) {
      setError(err.message);
    }
  };

  const isStaging = import.meta.env.MODE === "staging";

  return (
    <div style={{
      fontFamily: "'DM Sans', 'Helvetica Neue', sans-serif",
      backgroundColor: COLORS.bg,
      minHeight: "100vh",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      padding: 20,
    }}>
      <link href="https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500;600;700&display=swap" rel="stylesheet" />

      {isStaging && (
        <div style={{
          position: "fixed", top: 0, left: 0, right: 0,
          backgroundColor: COLORS.orange, color: "#fff",
          textAlign: "center", padding: "4px 0", fontSize: 12, fontWeight: 600,
          zIndex: 9999,
        }}>STAGING ENVIRONMENT</div>
      )}

      <div style={{
        backgroundColor: COLORS.surface,
        borderRadius: 16,
        border: `1px solid ${COLORS.border}`,
        padding: 40,
        width: "100%",
        maxWidth: 400,
        boxShadow: "0 4px 24px rgba(0,0,0,0.3)",
      }}>
        <div style={{ textAlign: "center", marginBottom: 32 }}>
          <div style={{
            width: 48, height: 48, borderRadius: 12, backgroundColor: COLORS.accent,
            display: "inline-flex", alignItems: "center", justifyContent: "center",
            color: "#fff", fontWeight: 700, fontSize: 22, marginBottom: 12,
          }}>C</div>
          <h1 style={{ fontSize: 20, fontWeight: 700, color: COLORS.text, marginBottom: 4 }}>
            Calibre
          </h1>
          <p style={{ fontSize: 13, color: COLORS.textMuted }}>
            Programme quality benchmarking
          </p>
        </div>

        <form onSubmit={handleSubmit}>
          <div style={{ marginBottom: 16 }}>
            <label style={{ fontSize: 13, fontWeight: 500, color: COLORS.textSecondary, display: "block", marginBottom: 6 }}>
              Email
            </label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              style={{
                width: "100%", padding: "10px 12px", fontSize: 14,
                border: `1px solid ${COLORS.border}`, borderRadius: 8,
                outline: "none", boxSizing: "border-box",
                backgroundColor: COLORS.surfaceAlt, color: COLORS.text,
              }}
            />
          </div>

          <div style={{ marginBottom: 20 }}>
            <label style={{ fontSize: 13, fontWeight: 500, color: COLORS.textSecondary, display: "block", marginBottom: 6 }}>
              Password
            </label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              style={{
                width: "100%", padding: "10px 12px", fontSize: 14,
                border: `1px solid ${COLORS.border}`, borderRadius: 8,
                outline: "none", boxSizing: "border-box",
                backgroundColor: COLORS.surfaceAlt, color: COLORS.text,
              }}
            />
          </div>

          {error && (
            <div style={{
              backgroundColor: COLORS.redLight, color: COLORS.red,
              padding: "8px 12px", borderRadius: 8, fontSize: 13, marginBottom: 16,
            }}>{error}</div>
          )}

          {resetSent && (
            <div style={{
              backgroundColor: COLORS.greenLight, color: COLORS.green,
              padding: "8px 12px", borderRadius: 8, fontSize: 13, marginBottom: 16,
            }}>Password reset email sent. Check your inbox.</div>
          )}

          <button
            type="submit"
            disabled={loading}
            style={{
              width: "100%", padding: "10px 0", fontSize: 14, fontWeight: 600,
              backgroundColor: COLORS.accent, color: "#fff", border: "none",
              borderRadius: 8, cursor: loading ? "not-allowed" : "pointer",
              opacity: loading ? 0.7 : 1,
            }}
          >
            {loading ? "Signing in..." : "Sign in"}
          </button>
        </form>

        <div style={{ textAlign: "center", marginTop: 16 }}>
          <button
            onClick={handleReset}
            style={{
              background: "none", border: "none", color: COLORS.accent,
              fontSize: 13, cursor: "pointer", textDecoration: "underline",
            }}
          >
            Forgot password?
          </button>
        </div>
      </div>
    </div>
  );
}
